<div class="notification-wrapper">
  
  <!-- 1. Bell Icon Trigger -->
  <div class="bell-trigger" (click)="op.toggle($event); togglePanel()" [class.active]="isPanelOpen">
    <i class="pi pi-bell bell-icon"></i>
    <!-- Unread Notification Badge -->
    <span *ngIf="unreadNotificationCount > 0" class="notification-badge">
      {{ unreadNotificationCount > 99 ? '99+' : unreadNotificationCount }}
    </span>
  </div>

  <!-- 2. PrimeNG 17 OverlayPanel -->
  <p-overlayPanel #op styleClass="custom-notification-overlay" (onHide)="onPanelHide()">
    <div class="notification-panel-content">
      
      <!-- Header: Title + Mark All as Read Action -->
      <div class="panel-header d-flex align-items-center justify-content-between">
        <h5 class="title m-0">NOTIFICATIONS</h5>
        <button class="mark-read-btn btn btn-link p-0 border-0"  *ngIf="unreadNotificationCount > 0" (click)="markAllAsRead()">
          Mark all as read
        </button>
      </div>

      <!-- Notification List -->
      <div class="notification-list" #scrollContainer (scroll)="onContainerScroll($event)">
        
        <!-- Empty State -->
        <div *ngIf="notifications.length === 0 && !isLoading" class="empty-state">
          <i class="pi pi-inbox"></i>
          <p>No notifications yet</p>
        </div>

        <!-- List Items -->
        <div 
          class="notification-item" 
          *ngFor="let item of notifications"
          [class.unread]="!item.is_read"
          (click)="handleClick(item)">
          
          <div class="item-content d-flex align-items-start">
            <!-- Icon Box -->
            <div class="icon-box">
              <i [class]="getIcon(item.type)"></i>
            </div>
            
            <!-- Text Content -->
            <div class="text-content flex-grow-1 min-width-0">
              <div class="top-row d-flex align-items-baseline justify-content-between">
                <h6 class="item-title text-truncate">{{ item.title }}</h6>
                <span class="item-time flex-shrink-0">{{ formatDate(item.created_at) }}</span>
              </div>
              <p class="item-subtitle">{{ item.subtitle }}</p>
              
              <!-- Extra Badges (Amount / Rating) -->
              <div class="badges-row d-flex align-items-center" *ngIf="item.amount || item.rating || !item.is_read">
                <span class="amount-badge" *ngIf="item.amount">
                  $ {{ item.amount }}
                </span>
                <span class="rating-badge d-inline-flex align-items-center" *ngIf="item.rating">
                  <span class="stars-container d-inline-flex align-items-center gap-1">
                    <i class="pi pi-star-fill text-warning" *ngFor="let star of getStarsArray(item.rating)"></i>
                  </span>
                </span>
                <span class="badge badge-new" *ngIf="!item.is_read && isToday(item.created_at)">New</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="loader-container d-flex align-items-center justify-content-center">
          <div class="spinner"></div>
        </div>

        <!-- End of list message -->
        <div *ngIf="!hasMoreData && notifications.length > 0" class="end-message text-center">
          <small>You're all caught up!</small>
        </div>

      </div>

      <!-- Footer: View All Notifications Link -->
      <div class="panel-footer text-center">
        <a class="view-all-link" (click)="viewAllNotifications()">
          View all notifications
        </a>
      </div>

    </div>
  </p-overlayPanel>
</div>